<template>
  <asc-page-loading-indicator
    :loading="(allUsersLoading || allRoleDataLoading) && !apiPageFailure.length"
  >
    <v-container fluid class="asc-user-template">
      <asc-tab :v-model="selectedTab" secondary @tabChange="handleTabChange">
        <template>
          <asc-tab-title title="Users" name="users" />
        </template>
        <template>
          <asc-tab-title title="Roles" name="roles" />
        </template>
      </asc-tab>
      <asc-tab-body :value="selectedTab" secondary>
        <asc-tab-item name="users">
          <asc-user-container></asc-user-container>
        </asc-tab-item>
        <asc-tab-item name="roles">
          <asc-role-container></asc-role-container>
        </asc-tab-item>
      </asc-tab-body>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscTabBody from '@/components/atoms/AscTabBody.vue'
import AscTabItem from '@/components/atoms/AscTabItem.vue'
import AscTabTitle from '@/components/atoms/AscTabTitle.vue'
import AscTab from '@/components/atoms/AscTab.vue'
import AscUserContainer from './AscUserContainer.vue'
import AscRoleContainer from './AscRoleContainer.vue'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import { mapState } from 'vuex'
import {
  ADMIN_CONSTS as AC,
  ROLE_MANAGEMENT_CONSTS as RM,
} from '@/stores/consts'
export default {
  name: 'AscUserRoleContainer',
  components: {
    AscTab,
    AscTabBody,
    AscTabItem,
    AscTabTitle,
    AscUserContainer,
    AscRoleContainer,
    AscPageLoadingIndicator,
  },
  data() {
    return {
      selectedTab: 'roles',
    }
  },
  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(AC.NAMESPACE, ['allUsersLoading']),
    ...mapState(RM.NAMESPACE, ['allRoleDataLoading']),
  },
  methods: {
    handleTabChange(whichTab) {
      this.selectedTab = whichTab
    },
  },
}
</script>

<style lang="scss">
.asc-user-template {
  background-color: $primary-white !important;
  .asc-tab__content--secondary {
    background-color: $primary-white !important;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 25px;
  }
  .asc-tabs .v-tabs-bar__content {
    background-color: rgb(240, 240, 240);
  }
}
</style>
